const chunk = (arr, size) => Array.from({
  length: Math.ceil(arr.length / size)
}, (v, i) => arr.slice(i * size, i * size + size));
const isPromise = p => p && typeof p.then === 'function' && typeof p.catch === 'function';

export { chunk, isPromise };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/utils/utils.js